import { z } from 'zod'

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }
  return { message: ctx.defaultError }
})

export const serviceSchema = z.object({
  id:  z.union([z.number().int(), z.string()]).optional(),
  idUsuario: z.union([z.number().int(), z.string()]),
  nome: z.string(),
  observacao:  z.union([z.number().int(), z.string()]).optional().nullable(),
  valor: z
    .any()
    .default(0)
    .transform((value) => parseFloat(value.toString().replaceAll('.', '').replace('R$ ', '').replace(',', '.'))),
  unidade: z.object({ id: z.string().transform((value) => Number(value || '0')) })
})

export type serviceForm = z.infer<typeof serviceSchema>
